<template>
    <div class="c-form" @submit="submit">
        <div class="c-form__title">
          {{ $t('landing.reset_password.title') }}
        </div>
        <div class="c-form__wrapper" v-bind:class="{ 'is-loading': isLoading }">
            <form class="c-form__form">
                <p class="c-form__field" v-bind:class="{ 'has-error': hasErrors }">
                    <label
                        class="c-form__label"
                        for="username">
                        {{ $t('landing.reset_password.password') }}
                    </label>
                    <input
                      v-model="password"
                      class="c-form__input"
                      type="password"
                      name="password"
                      id="password"
                      required>
                      <span
                        v-if="hasErrors"
                        class="c-form__error">
                          {{ errorMessage() }}
                      </span>
                </p>
                <p class="c-form__field" v-bind:class="{ 'has-error': hasErrors }">
                    <label
                        class="c-form__label"
                        for="username">
                        {{ $t('landing.reset_password.repeat_password') }}
                    </label>
                    <input
                      v-model="repeat_password"
                      class="c-form__input"
                      type="password"
                      name="repeat_password"
                      id="repeat_password"
                      required>
                      <span
                        v-if="hasErrors"
                        class="c-form__error">
                          {{ errorMessage() }}
                      </span>
                </p>
                <p class="c-form__actions">
                    <input
                    class="c-form__submit"
                    type="submit"
                    :value="$t('landing.remember_pwd.submit.text')">
                </p>
            </form>
        </div>
    </div>
</template>
<script>
export default {
  name: 'ResetPasswordForm',
  props: {
    onSubmit: {
      type: Function,
      required: true,
    },
    errors: {
      type: Array,
    },
    isLoading: {
      type: Boolean,
    },
    onGoBack: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      password: '',
      repeat_password: '',
      notEqualsError: false,
    }
  },
  computed: {
    hasErrors() {
      return this.errors.length > 0 || this.notEqualsError === true
    },
  },
  methods: {
    submit(e) {
      e.preventDefault()

      if (!this.validate()) {
        this.notEqualsError = true
      } else {
        this.notEqualsError = false
        this.onSubmit(this.$data, e)
      }
    },
    errorMessage() {
      if (this.notEqualsError === true) {
        return this.$t('errors.reset_password.diff_passwords')
      }

      return this.$t('errors.reset_password.invalid_passwords')
    },
    validate() {
      if (this.password !== this.repeat_password) {
        return false
      }

      return true
    },
  },
}
</script>
